import React, { useEffect, useState } from 'react';
import { Button, Space, Table, List, Select, DatePicker, Form, message, Modal } from 'antd';
import { getUsers, getStatistic, getStatisticSettle, getMeal, getUser, getStatisticSettleInDay, addOrUpdateDish, settlementDebtorByOwner, settlementMeal, checkmealisdone, getMealsByID } from '../../service/auth/AuthService';
import type { ColumnsType } from 'antd/es/table';
import type { DatePickerProps } from 'antd';
import moment from 'moment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatMoney } from '../../helper/formatCurrencyHelper';

import './Assume.scss';
import { iteratee } from 'lodash';
import { format } from 'prettier';

interface DataType {
	key: string;
	name: string;
	age: number;
	address: string;
	tags: string[];
	id: number;
	created: any;
	shoplink: any;
	status: any;
	mealid: any;
	need2pay: any;
	price: any;
	shopprice: any;
	totalneed2pay: any;
}

const dataSort = [
	{
		title: 'Bạn là chủ nợ',
		value: 'owner',
	},
	{
		title: 'Bạn là con nợ',
		value: 'debtor',
	},
];

export default function Assume() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalAsumeOpen, setIsModalAsumeOpen] = useState(false);
	const [isModalAsumeDetailOpen, setIsModalAsumeDetailOpen] = useState(false);
	const [isModalOpenSettlement, setIsModalOpenSettlement] = useState(false);
	const [isModalOpenSettlementUser, setIsModalOpenSettlementUser] = useState(false);
	const [typeUser, setTypeUser] = useState('debtor');
	const [formAssume] = Form.useForm();
	const [formSettelInday] = Form.useForm();
	const [userRender, setUserRender] = useState<any>([]);
	const [userRenderTable, setUserRenderTable] = useState<any>([]);
	const [arrayMeal, setArrayMeal] = useState<any>([]);
	const [user, setUser] = useState<any>('');
	const [inforConfirm, setInforConfirm] = useState<any>("");
	const [meal, setMeal] = useState<any>("");
	const [newArrayUserRender, setNewArrayUserRender] = useState<any>("");
	const [arrShowTable, setArrShowTable] = useState<any>([]);


	const navigate = useNavigate();
	const dateFormat = 'YYYY/MM/DD';
	const columns: ColumnsType<DataType> = [
		{
			title: 'Ngày tạo',
			dataIndex: 'created',
			key: 'created'
		},
		{
			title: 'Người tạo',
			dataIndex: 'creator',
			key: 'creator',
		},
		{
			title: 'ID bữa ăn',
			dataIndex: 'id',
			key: 'id',
			defaultSortOrder: 'descend',
			sorter: (a, b) => {
				return moment(a.id).valueOf() - moment(b.id).valueOf();
			},
		},
		{
			title: 'Người trả',
			dataIndex: 'payer',
			key: 'payer',
		},
		{
			title: 'Link shop',
			dataIndex: 'shoplink',
			key: 'shoplink',
			render: (_, record) => {
				return (
					<a href={record.shoplink} target="_blank" rel="noreferrer">
						{record.shoplink}
					</a>
				);
			},
		},
		{
			title: 'Tổng số tiền',
			dataIndex: 'shopprice',
			key: 'shopprice',
			render: (_, record) => {
				return <p>{record.shopprice} VND</p>;
			},
		},
		{
			title: 'Tổng tiền thanh toán',
			dataIndex: 'totalneed2pay',
			key: 'totalneed2pay',
			render: (_, record) => {
				return <p>{record.totalneed2pay} VND</p>;
			},
		},

		{
			title: 'Trạng thái',
			dataIndex: 'status',
			key: 'status',
			defaultSortOrder: 'descend',
			render: (_, record) => {
				return (
					<p
						className={
							record.status == 'new'
								? 'red-character'
								: record.status == 'paid'
									? 'yellow-character'
									: 'green-character'
						}
					>
						{record.status == 'new'
							? 'Mới'
							: record.status == 'paid'
								? 'Đã thanh toán -  đang thu'
								: 'Đã tính tiền'}
					</p>
				);
			},
			sorter: (a, b) => {
				return stringToCheck(a.status) - stringToCheck(b.status);
			},
		},
		{
			title: 'Danh sách người nợ',
			// dataIndex: 'status',
			// key: 'status',
			render: (_, record) => (
				<Space size="middle">
					<Button
						onClick={() => {
							showAsumeDetail(record.id);
							return;
						}}
					>
						Xem chi tiết
					</Button>
				</Space>
			),
		},
	];

	const columnDetails: ColumnsType<DataType> = [
		{
			title: 'Ngày tạo',
			dataIndex: 'created',
			key: 'created',
		},
		{
			title: 'ID bữa ăn',
			dataIndex: 'mealid',
			key: 'mealid',
		},
		{
			title: 'Món ăn',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Giá',
			dataIndex: 'price',
			key: 'price',
			// render: (_, record) => {
			// 	return (
			// 		<p
			// 			className="mb-0"
			// 			onClick={() => {
			// 				console.log(record);
			// 			}}
			// 		>
			// 			{parseInt(record.price)}
			// 		</p>
			// 	);
			// },
		},
		{
			title: 'Giá thực tế',
			dataIndex: 'need2pay',
			key: 'need2pay',
			// render: (_, record) => {
			// 	return (
			// 		<p
			// 			className="mb-0"
			// 			// className={
			// 			// 	record.status == 'new'
			// 			// 		? 'red-character'
			// 			// 		: record.status == 'paid'
			// 			// 		? 'yellow-character'
			// 			// 		: 'green-character'
			// 			// }
			// 		>
			// 			{formatMoney(record.need2pay)}
			// 		</p>
			// 	);
			// },
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			key: 'status',
			render: (_, record) => {
				return (
					<p
						className={
							record.status == 'new'
								? 'red-character'
								: record.status == 'paid'
									? 'yellow-character'
									: 'green-character'
						}
					>
						{record.status == 'new'
							? 'Chưa trả tiền'
							: record.status == 'paid'
								? 'Đã trả (Hãy xác nhận nếu đã nhận)'
								: 'Đã nhận'}
					</p>
				);
			},
		},
		{
			title: 'Người nợ',
			dataIndex: 'userid',
			key: 'userid',
		},
		{
			title: 'Trả nợ',
			dataIndex: '',
			key: '',
			render: (_, record) => {
				return (
					<Button
						onClick={() => {
							handleConfirm(record);
						}}
						// disabled={record.status === 'new' || record.status === 'done' || meal.status === 'done' || meal.status === 'deleted' || meal.status === 'new'}
						disabled={record.status === 'done'}
						type="primary"
					>
						Xác nhận
					</Button>
				);
			},
		},
	];

	const columnNews: ColumnsType<DataType> = [
		{
			title: 'Ngày tạo',
			dataIndex: 'created',
			key: 'created',
			defaultSortOrder: 'descend',
			sorter: (a, b) => {
				return moment(a.created).valueOf() - moment(b.created).valueOf();
			},
		},
		{
			title: 'ID bữa ăn',
			dataIndex: 'mealid',
			key: 'mealid',
			defaultSortOrder: 'descend',
			sorter: (a, b) => {
				return moment(a.mealid).valueOf() - moment(b.mealid).valueOf();
			},
		},
		{
			title: 'Món ăn',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Giá',
			dataIndex: 'price',
			key: 'price',
			render: (_, record) => {
				return <p>{record.price} VND</p>;
			},
		},
		{
			title: 'Giá thực tế',
			dataIndex: 'need2pay',
			key: 'need2pay',
			render: (_, record) => {
				return <p>{record.need2pay} VND</p>;
			},
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			key: 'status',
			render: (_, record) => {
				return (
					<p
						className={
							record.status == 'new'
								? 'red-character'
								: record.status == 'paid'
									? 'yellow-character'
									: 'green-character'
						}
					>
						{record.status == 'new'
							? 'Chưa trả tiền'
							: record.status == 'paid'
								? 'Đã trả (chờ xác nhận)'
								: 'Đã trả tiền'}
					</p>
				);
			},
			sorter: (a, b) => {
				return stringToCheck(a.status) - stringToCheck(b.status);
			},
		},
		{
			title: 'Chủ nợ',
			dataIndex: 'payer',
			key: 'payer',
		},
		{
			title: 'Người tạo',
			dataIndex: 'creator',
			key: 'creator',
		},
		{
			title: 'Shop Link',
			dataIndex: 'shoplink',
			key: 'shoplink',
			render: (_, record) => {
				return (
					<a href={record.shoplink} target="_blank" rel="noreferrer">
						{record.shoplink}
					</a>
				);
			},
		},
		{
			title: 'Trả nợ',
			dataIndex: '',
			key: '',
			render: (_, record) => {
				return (
					<Button
						onClick={() => {
							handlePayDishOfThisMeal(record);
						}}
						disabled={record.status === 'done' || record.status === 'deleted' || record.status === 'paid'}
						type="primary"
					>
						Trả nào!!!
					</Button>
				);
			},
		},
	];

	const paramsStatisticInitial = {
		type: 'debtor',
		start: moment().startOf('month').format('YYYY-MM-DDT00:00:00'),
		end: moment().endOf('month').format('YYYY-MM-DDT23:59:59')
	};

	function stringToCheck(string: any) {
		if(string == "done") {
			return 1;
		} else if(string == "new"){
			return 2;
		} else if(string == "paid"){
			return 3;
		} else {
			return 0;
		}
	}

	function handlePayDishOfThisMeal(record: any) {
		const text = "Bạn sẽ thanh toán món này???";
		if (confirm(text) === true) {
			const paramsSendDish = [
				{
					name: record.name,
					price: parseInt(record.price.toString().replaceAll('.', '')),
					need2pay: parseInt(record.need2pay.toString().replaceAll('.', '')),
					userid: userRender.find((item: any, index: number) => {
						if (item.fullname === record.userid) {
							return item;
						}
					})?.id,
					mealid: record.mealid,
					status: 'paid',
					created: moment(record.created).toISOString(),
					modified: moment(record.modified).toISOString(),
				},
			];

			addOrUpdateDish(paramsSendDish)
				.then(res => {
					// window.location.replace("/assume");
					onFinish(formAssume.getFieldsValue());
					return;
				})
				.catch(err => {
					// console.log(err);
					message.error('Đã xảy ra lỗi');
					return;
				});
		} else {
			return;
		}
	}

	useEffect(() => {
		getUsers()
			.then(res => {
				// console.log(res);
				setUserRender(res.data.data);
			})
			.catch(err => {
				// console.log(err);
			});
		getUser()
			.then(res => {
				// console.log(res);
				setUser(res?.data.data);
			})
			.catch(err => {
				// console.log(err);
			});
		getMeal()
			.then(res => {
				// console.log(res);
				setArrayMeal(res.data.result);
			})
			.catch(err => {
				// console.log(err);
			});

		getStatistic(paramsStatisticInitial)
			.then(res => {
				// console.log(res.data.result);
				setUserRenderTable(res.data.result);

			})
			.catch(err => {
				// console.log(err);
				setUserRenderTable([]);
			});
	}, []);

	const { Option } = Select;
	const debtString: any = [];
	const ownerString: any = [];
	let realUsersMealTable: any = [];
	let realUsersMealTableNew: any = [];
	let realUsersMealTableNewGroupPayer: any = [];
	let realUsersMealTableGroupPayer: any = [];

	updateAsume();
	function updateAsume() {
		realUsersMealTable = userRenderTable.map((item: any, index: number) => {
			return {
				created: moment(item.created).format('YYYY-MM-DD'),
				creator: userRender.find((itemChild: any, index: number) => {
					if (item.creator === itemChild.id) {
						return item;
					}
				})?.fullname,

				payer: userRender.find((itemChild: any, index: number) => {
					if (item.payer === itemChild.id) {
						return item;
					}
				})?.fullname,
				shoplink: item.shoplink,
				status: item.status,
				shopprice: formatMoney(item.shopprice),
				id: item.id,
				dishes: item.dishes,
				totalneed2pay: formatMoney(item.totalneed2pay),
			};
		});

		realUsersMealTableNew = userRenderTable.filter((item: any, index: number) => {
			if (item.meal?.payer != user.id) {
				return item;
			}
		});

		realUsersMealTableNew = realUsersMealTableNew.map((item: any, index: number) => {
			return {
				created: moment(item.created).format('YYYY-MM-DD'),
				mealid: item.mealid,
				name: item.name,
				price: formatMoney(item.price),
				need2pay: formatMoney(item.need2pay),
				status: item.status,
				userid: userRender.find((itemChild: any, index: number) => {
					if (item.userid === itemChild.id) {
						return item;
					}
				})?.fullname,
				payer: userRender.find((itemChild: any, index: number) => {
					if (item.meal?.payer === itemChild.id) {
						return item;
					}
				})?.fullname,
				creator: userRender.find((itemChild: any, index: number) => {
					if (item.meal?.creator === itemChild.id) {
						return item;
					}
				})?.fullname,
				shoplink: item.meal?.shoplink,
				meal: item.meal
			};
		});

		// console.log(realUsersMealTableNew);

		realUsersMealTableNewGroupPayer = groupBy(realUsersMealTableNew, "payer");

		if (typeUser === "owner") {
			const arrDishesDebt: any = [];

			realUsersMealTable?.forEach((e: any) => {
				e?.dishes?.forEach((element: any) => {
					arrDishesDebt.push(element)
				});

			});

			if (arrDishesDebt.length > 0) {
				if (arrDishesDebt[0]?.userid) {
					realUsersMealTableGroupPayer = groupBy(arrDishesDebt, "userid");
				}
			}

			realUsersMealTableGroupPayer?.forEach((e: any) => {
				let debtValue = 0;
				let debtValueSend = 0;
				const userid = e[0]?.userid;
				const creatorName = userRender?.find((itemChild: any, index: number) => {
					if (userid === itemChild.id) {
						return itemChild;
					}
				})?.fullname;

				e?.forEach((element: any) => {
					if (element.status != 'done') {
						if (element.status == 'paid') {
							debtValueSend += parseInt(element.need2pay?.toString().replaceAll('.', ''));
						}
						debtValue += element.need2pay
					} else {
						debtValue += 0
					}
				});
				if (debtValue > 0) {
					let string = `${creatorName} nợ bạn số tiền ${formatMoney(debtValue)} VND`;
					if (debtValueSend > 0) {
						string += ` (Chờ xác nhận: ${formatMoney(debtValueSend)} VND)`
					}
					string += `*${userid}`
					ownerString.push(string);
				}
			});
			if (ownerString.length == 0) {
				ownerString.push(`Không có ai nợ bạn!`);
			}
		} else {
			// console.log(realUsersMealTableNew);
			realUsersMealTableNewGroupPayer?.forEach((e: any) => {
				let debtValue = 0;
				let debtValueSend = 0;
				const payer = e[0]?.meal?.payer;
				// console.log(userRender);
				const creatorName = userRender?.find((itemChild: any, index: number) => {
					if (payer === itemChild.id) {
						return itemChild;
					}
				})?.fullname;

				const number_account = userRender?.find((itemChild: any, index: number) => {
					if (payer === itemChild.id) {
						return itemChild;
					}
				})?.number_account;

				const name_account = userRender?.find((itemChild: any, index: number) => {
					if (payer === itemChild.id) {
						return itemChild;
					}
				})?.name_account;

				e?.forEach((element: any) => {
					if (element.status != 'done') {
						if (element.status == 'paid') {
							debtValueSend += parseInt(element.need2pay?.toString().replaceAll('.', ''));
						}
						debtValue += parseInt(element.need2pay?.toString().replaceAll('.', ''));
					} else {
						debtValue += 0
					}
				});
				if (debtValue > 0) {
					let string = `${creatorName} `;

					if (number_account) {
						string += `(${name_account} - ${number_account})`
					}

					string += `: ${formatMoney(debtValue)} VND`;

					if (debtValueSend > 0) {
						string += ` (Chờ xác nhận: ${formatMoney(debtValueSend)} VND)`
					}

					debtString.push(string);
				}
			});
			if (debtString.length == 0) {
				debtString.push(`Bạn không nợ ai!`);
			}
		}
	}

	function groupBy(collection: any, property: any) {
		let i = 0, val, index;
		const values = [], result = [];
		for (; i < collection.length; i++) {
			val = collection[i][property];
			index = values.indexOf(val);
			if (index > -1)
				result[index].push(collection[i]);
			else {
				values.push(val);
				result.push([collection[i]]);
			}
		}
		return result;
	}

	const handleSettleInday = () => {
		setIsModalOpen(true);
	};

	const handleOpenAssume = () => {
		setIsModalAsumeOpen(true);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setIsModalAsumeOpen(false);
		setIsModalAsumeDetailOpen(false);
	};

	const handleCancelOpenSettlementUser = () => {
		setIsModalOpenSettlementUser(false);
	};

	const handleCancelOpenSettlement = () => {
		setIsModalOpenSettlement(false);
	};

	const onFinish = (values: any) => {
		let from = moment().startOf('month').format('YYYY-MM-DDT00:00:00');
		let to = moment().endOf('month').format('YYYY-MM-DDT23:59:59');

		if (values.from) {
			from = moment(new Date(values.from)).format('YYYY-MM-DDT00:00:00');
		}

		if (values.to) {
			to = moment(new Date(values.to)).format('YYYY-MM-DDT23:59:59');
		}

		if (from > to) {
			message.error('Sai ngày!!!');
		}

		const paramsStatistic = {
			type: values.people,
			start: from,
			end: to,
		};
		// console.log(paramsStatistic);
		setTypeUser(values.people);
		if(typeUser === 'owner') {
			realUsersMealTableNew = [];
		} else {
			realUsersMealTable = [];
		}
		getStatistic(paramsStatistic)
			.then(res => {
				// console.log(res.data.result);
				setUserRenderTable(res.data.result);
				updateAsume();
			})
			.catch(err => {
				// console.log(err);
				setUserRenderTable([]);
			});
	};

	const onFinishInDay = () => {

		if (realUsersMealTableNew.length < 1) {
			message.error('Không thể tất toán!!!');
			return;
		}

		const text = "Bạn sẽ tất toán???";
		if (confirm(text) === false) {
			return
		}

		const value = formSettelInday.getFieldsValue();

		let frominDay = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).format('YYYY-MM-DD 00:00:00');
		let toinDay = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).format('YYYY-MM-DD 23:59:59');
		if (value.frominDay) {
			frominDay = moment(new Date(value.frominDay)).format('YYYY-MM-DD 00:00:00');
		}
		if (value.toinDay) {
			toinDay = moment(new Date(value.toinDay)).format('YYYY-MM-DD 23:59:59');
		}

		if (frominDay > toinDay) {
			message.error('Sai ngày!!!');
		}
		const paramsStatistic = {
			frominDay: frominDay,
			toinDay: toinDay
		};
		getStatisticSettleInDay(paramsStatistic)
			.then((res: any) => {
				// console.log(res);
				// setUserRenderTable(res.data.result);
				message.success('Bạn tất toán trong ngày thành công');
				handleCancel();

			})
			.catch((err: any) => {
				// console.log(err);
				message.error('Bạn tất toán trong ngày chưa thành công');
			});
	};

	const handleSettle = () => {
		if (realUsersMealTableNew.length < 1) {
			message.error('Không thể tất toán!!!');
			return;
		}
		const text = "Bạn sẽ tất toán???";
		if (confirm(text) === false) {
			return
		}
		getStatisticSettle()
			.then(res => {
				// console.log(res);
				message.success('Bạn đã tất toán thành công');
			})
			.catch(err => {
				// console.log(err);
				message.error('Bạn tất toán chưa thành công');
			});
	};

	const handleSettleByUser = (userid: any, from: any, to: any) => {
		const text = "Bạn sẽ tất toán người nợ này???";
		if (confirm(text) === false) {
			return
		}

		// console.log(`${userid}`);
		const params = {
			debtor: userid,
			fromday: from,
			today: to
		}
		settlementDebtorByOwner(params)
			.then(res => {
				// console.log(res);
				message.success('Bạn đã tất toán thành công');
				window.location.replace("/assume");
			})
			.catch(err => {
				// console.log(err);
				message.error('Bạn tất toán chưa thành công');
			});
		return;
	}

	const showSettleOwner = (item: any) => {
		const data = item.split("*");
		const text = data[0];
		const userid = data[1];

		const fromto = formAssume.getFieldsValue();
		let from = moment().startOf('month').format('YYYY-MM-DDT00:00:00');
		let to = moment().endOf('month').format('YYYY-MM-DDT23:59:59');

		if (fromto.from) {
			from = moment(new Date(fromto.from)).format('YYYY-MM-DDT00:00:00');
		}

		if (fromto.to) {
			to = moment(new Date(fromto.to)).format('YYYY-MM-DDT23:59:59');
		}

		return (
			<div className="w-[100%]" >
				<div className="w-[78%] " style={{ float: 'left' }}>
					{text}
				</div>
				{item === "Không có ai nợ bạn!" ? '' : (
					<div className="w-[20%] mr-0" style={{ float: 'left' }}>
						<Button  onClick={() => handleSettleByUser(userid, from, to)} >
							Tất toán
						</Button>
					</div>
				)}
			</div>
		)
	}

	const showSettleDebtor = (item: any) => (
		<div className="w-[100%]">
			{item}
		</div>
	)

	const handleSettlementMeal = () => {
		setIsModalOpenSettlement(true);
	}

	const handleSettlement = () => {
		const paramsStatistic = {
			mealid: meal.id
		};
		settlementMeal(paramsStatistic)
			.then((res: any) => {
				// console.log(res);
				// setUserRenderTable(res.data.result);
				message.success('Bạn tất toán bữa ăn thành công');
				handleCancelOpenSettlement();
				handleCancel();
				onFinish(formAssume.getFieldsValue());
			})
			.catch((err: any) => {
				// console.log(err);
				message.error('Bạn tất toán bữa ăn chưa thành công');
			});
	}

	const handleSettlementUser = () => {
		if (!inforConfirm) {
			return;
		}
		const paramsSendDish = [
			{
				name: inforConfirm.name,
				price: parseInt(inforConfirm.price.toString().replaceAll('.', '')),
				need2pay: parseInt(inforConfirm.need2pay.toString().replaceAll('.', '')),
				userid: userRender.find((item: any, index: number) => {
					if (item.fullname === inforConfirm.userid) {
						return item;
					}
				})?.id,
				mealid: meal.id,
				status: 'done',
				created: moment(meal.created).toISOString(),
				modified: moment(meal.modified).toISOString(),
			},
		];

		addOrUpdateDish(paramsSendDish)
			.then(res => {
				handleCancelOpenSettlementUser();
				message.success('Bạn tất toán người nợ này thành công');
				handleCancelOpenSettlement();
				handleCancel();
				showAsumeDetail(meal.id);
			})
			.catch(err => {
				// console.log(err);
			});

		const params = {
			mealid: meal.id
		}
		checkmealisdone(params)
			.then(res => {
				console.log(res.data.status);
				if (res.data.status) {
					message.success('Bạn tất toán hết tất cả bữa ăn');
					handleCancelOpenSettlementUser();
					handleCancelOpenSettlement();
					handleCancel();
				}
			})
			.catch(err => {
				// console.log(err);
			});
	}

	const handleConfirm = (dish: any) => {
		setInforConfirm(dish);
		setIsModalOpenSettlementUser(true);
	}

	const showAsumeDetail = (mealid: any) => {
		console.log(mealid);
		const params = {
			mealid: mealid
		}
		checkmealisdone(params)
			.then(res => {
				console.log(res.data.status);
				if (res.data.status) {
					// message.success('Bữa ăn này đã được tất toán');
					handleCancelOpenSettlementUser();
					handleCancelOpenSettlement();
					handleCancel();
				}
				return;
			})
			.catch(err => {
				// console.log(err);
			});
		getMealsByID(mealid)
			.then(res => {
				console.log(mealid);

				setMeal(res.data.result);
				const dishes = res.data.result?.dishes?.filter((item: any, index: number) => {
					if (item.userid !== user.id && item.need2pay != 0) {
						return item;
					}
				});
				const newArrayUserRender = dishes?.map((item: any, index: number) => {
					return {
						created: moment(item.created).format('DD-MM-YYYY'),
						userid: userRender?.find((itemChild: any, index: number) => {
							if (item.userid === itemChild.id) {
								return item;
							}
						})?.fullname,
						mealid: item.mealid,
						name: item.name,
						price: formatMoney(item.price) + " VND",
						need2pay: formatMoney(item.need2pay) + " VND",
						status: formatMoney(item.status),
						modified: item.modified
					};
				});
				setNewArrayUserRender(newArrayUserRender);

				setIsModalAsumeDetailOpen(true);
			})
			.catch(err => {
				// console.log(err);
			});
	}

	const totalPayOwner = () => {
		let debtValue = 0;
		realUsersMealTableGroupPayer?.forEach((e: any) => {
			e?.forEach((element: any) => {
				if (element.userid != user.id) {
					debtValue += Math.ceil(element.need2pay)
				} else {
					debtValue += 0
				}
			});
		});
		return debtValue;
	};

	const totalPayDeptor = Math.ceil(
		realUsersMealTableNew.reduce((initial: any, item: any) => {
			if (item.status === "new") {
				return initial + parseInt(item.need2pay?.toString().replaceAll('.', ''));
			} else {
				return initial + 0;
			}

		}, 0),
	);

	return (
		<div className="text-center text-base ">
			<h1 className="my-5 text-lg">Thống kê</h1>

			<Form
				labelCol={{ span: 8 }}
				wrapperCol={{ span: 32 }}
				name="dynamic_form_nest_item"
				onFinish={onFinish}
				autoComplete="off"
				form={formAssume}
			>
				<div className="w-full mx-auto border border-gray-500 p-5 rounded-lg form-order">
					<div className="flex justify-between items-center mx-auto">
						<p className="text-red-600">Người đăng nhập hiện tại : {user?.fullname}</p>
						<div className="flex mb-5">
							<p className="w-40 mb-0 text-left flex items-center">Từ ngày:</p>
							<Form.Item name="from" className="mb-0 date-calendar">
								<DatePicker
									className="w-[10rem] "
									defaultValue={moment(
										moment().startOf('month'),
										dateFormat,
									)}
									format={dateFormat}
								/>
							</Form.Item>
						</div>
						<div className="flex mb-5">
							<p className="w-40 mb-0 text-left flex items-center">Đến ngày:</p>
							<Form.Item name="to" className="mb-0 date-calendar">
								<DatePicker
									className="w-[10rem] mb-0  "
									defaultValue={moment(
										moment().endOf('month'),
										dateFormat,
									)}
									format={dateFormat}
								/>
							</Form.Item>
						</div>
						<div className="flex mb-5 items-center">
							<Form.Item name="people" className="mb-0 date-calendar" initialValue="debtor">
								<Select className="w-full">
									{dataSort.map((item: any, index: number) => {
										return (
											<>
												<Option key={index} value={item.value}>
													{item.title}
												</Option>
											</>
										);
									})}
								</Select>
							</Form.Item>
							<Form.Item wrapperCol={{ offset: 8, span: 32 }} className="button-submit ml-5">
								<div className="w-[200px] mx-auto flex">
									<Button type="primary" htmlType="submit">
										Xem
									</Button>
								</div>
							</Form.Item>
						</div>
					</div>
					<div className="flex justify-between mb-5 float-right pl-[3.5rem]">
						<div className="flex mb-5 mr-5 font-bold text-blue-600">
							{typeUser === 'owner'
								? `Tổng tiền nhận (Tổng tiền thanh toán - Tổng tiền phần ăn của bạn) : ${formatMoney(Math.ceil(totalPayOwner()))} VND`
								: `Tổng tiền phải trả : ${formatMoney(totalPayDeptor)} VND`}
						</div>
						{/* <Button className="w-[10rem]" onClick={handleSettle} disabled={typeUser !== 'owner'}>
							Tất toán
						</Button> */}

						<Button className="w-[10rem]" onClick={handleSettleInday} disabled={typeUser !== 'owner'}>
							Tất toán
							{/* trong ngày */}
						</Button>

						<Button className="w-[10rem]" onClick={handleOpenAssume} >
							Xem thông tin nợ
						</Button>

					</div>
					<Table
						columns={typeUser === 'owner' ? columns : columnNews}
						dataSource={typeUser === 'owner' ? realUsersMealTable : realUsersMealTableNew}
						pagination={false}
						scroll={{ y: 500 }}
					/>
				</div>
			</Form>

			<Modal centered visible={isModalOpen} onOk={onFinishInDay} onCancel={handleCancel}>
				<Form
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 32 }}
					name="dynamic_form_nest_item"
					autoComplete="off"
					form={formSettelInday}
				>
					<div className="flex mb-5">
						<p className="mb-0 text-left flex items-center">Từ :</p>
						<Form.Item name="frominDay" className="mb-0 date-calendar">
							<DatePicker
								className="w-[10rem] "
								defaultValue={moment(
									moment(
										new Date(
											new Date().getFullYear(),
											new Date().getMonth(),
											new Date().getDate(),
										),
									),
									dateFormat,
								)}
								format={dateFormat}
							/>
						</Form.Item>
						<p className="ml-10 mb-0 text-left flex items-center">Đến :</p>
						<Form.Item name="toinDay" className="mb-0 date-calendar">
							<DatePicker
								className="w-[10rem] "
								defaultValue={moment(
									moment(
										new Date(
											new Date().getFullYear(),
											new Date().getMonth(),
											new Date().getDate(),
										),
									),
									dateFormat,
								)}
								format={dateFormat}
							/>
						</Form.Item>
					</div>
				</Form>
			</Modal>

			<Modal centered visible={isModalAsumeOpen} onCancel={handleCancel} onOk={handleCancel}>
				<List
					header={<div>Thông tin nợ</div>}
					dataSource={typeUser === 'owner' ? ownerString : debtString}
					bordered={false}
					renderItem={(item: any) => (
						<List.Item
						>
							{typeUser === 'owner' ? showSettleOwner(item) : showSettleDebtor(item)}
						</List.Item>
					)}
				/>
			</Modal>
			<Modal centered visible={isModalAsumeDetailOpen} onCancel={handleCancel} onOk={handleCancel}>
				<div className="text-center text-base ">
					<div className="flex justify-evenly">
						<h4>Chi tiết nợ</h4>
					</div>
					<div className="flex justify-evenly">
						{/* <p className="text-red-600">Tổng số tiền đã thu : {formatMoney(totalPriceInitial)} VND</p> */}
						{/* <p className="text-red-600">Tổng số tiền cần thu nợ : {formatMoney(totalMustPriceInitial)} VND</p> */}
						<Button
							type="primary"
							danger
							hidden={meal.status == "done"}
							onClick={() => {
								handleSettlementMeal();
							}}
						>
							Tất toán bữa ăn
						</Button>
					</div>

					<div className="w-full mx-auto border border-gray-500 p-5 rounded-lg form-order">
						<Table columns={columnDetails} dataSource={newArrayUserRender} pagination={false} />
					</div>
				</div>
			</Modal>
			<Modal centered visible={isModalOpenSettlementUser} onOk={handleSettlementUser} onCancel={handleCancelOpenSettlementUser}>
				<p className="text-center">Bạn có đồng ý xác nhận đã thanh toán</p>
			</Modal>
			<Modal centered visible={isModalOpenSettlement} onOk={handleSettlement} onCancel={handleCancelOpenSettlement}>
				<p className="text-center">Bạn có đồng ý tất toán bữa ăn này??</p>
			</Modal>
		</div>
	);
}
